import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IJwtPeticion, JwtPeticion } from 'src/app/core/modelo/jwt-peticion.model';
import { SeguridadService } from 'src/app/core/servicios/seguridad.service';
import { ModalCargandoComponent } from 'src/app/shared/componentes/modal-cargando/modal-cargando.component';
import { ModalErrorComponent } from 'src/app/shared/componentes/modal-error/modal-error.component';
import { ModalExitoComponent } from 'src/app/shared/componentes/modal-exito/modal-exito.component';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public titulo: string = 'Módulo de certificaciones';
  public version: string = 'Versión en construcción - CITCD';
  public formulario: FormGroup;
  public formToken: FormGroup;
  public esAdmin = false;
  public esTokenValido = false;

  constructor(private modalService: NgbModal, private fb: FormBuilder, private seguridadService: SeguridadService, private router: Router) {
    
    this.formulario = this.fb.group({
      usuario: this.fb.control('', Validators.compose([Validators.required])),
      contrasena: this.fb.control('', Validators.compose([Validators.required])),
    });

    this.formToken = this.fb.group({
      token: this.fb.control('',Validators.compose([Validators.required]))
    });
  }

  ngOnInit(): void {

  }

  // Eventos

  onSubmitValidarCredenciales(event: Event): void {
    event.preventDefault();
    if (this.formulario.valid) {
      const jwt: IJwtPeticion = this.getJwtPeticion();
      this.validarCredenciales(jwt);
    } else {
      const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
      refError.componentInstance.mensaje = 'Por favor, verifique que todos los campos estén completos';
    }
  }

  onSubmitValidarTokenInicioSesionYAutenticar(event: Event): void {
    event.preventDefault();
    if (this.formulario.valid) {
      const jwt: IJwtPeticion = this.getJwtPeticion();
      const token: string = this.getToken()?.value || '';
      this.validarTokenInicioSesionYAutenticar(jwt, token);
    } else {
      const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
      refError.componentInstance.mensaje = 'Por favor, verifique que todos los campos estén completos';
    }
  }

  // Getters

  getUsuario(): AbstractControl | null {
    return this.formulario.get('usuario');
  }

  getContrasena(): AbstractControl | null {
    return this.formulario.get('contrasena');
  }

  getToken(): AbstractControl | null {
    return this.formToken.get("token");
  }

  // Fetch

  private validarCredenciales(jwt: IJwtPeticion): void {
    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });
    this.seguridadService.validarCredenciales(jwt).subscribe(
      (res) => {
        //console.log(res);
        this.modalService.dismissAll();
        const refExito = this.modalService.open(ModalExitoComponent, { animation: true, backdrop: 'static', keyboard: false });
        refExito.componentInstance.mensaje = 'Se ha enviado un código de verificación a su correo: ' + res.mensaje;

        this.esTokenValido = true;
        this.getToken()?.setValidators(Validators.compose([Validators.required]))
        this.getToken()?.updateValueAndValidity();
      },
      (err) => {
      
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = err.error.message;
      });

  }

  private validarTokenInicioSesionYAutenticar(jwt: IJwtPeticion, token: string): void {
    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });
    this.seguridadService.validarTokenInicioSesionYAutenticar(jwt, token).subscribe(
      (res) => {
        //console.log(res);
        this.modalService.dismissAll();
        //const refExito = this.modalService.open(ModalExitoComponent, { animation: true, backdrop: 'static', keyboard: false });
        //refExito.componentInstance.mensaje = 'Bienvenido(a)';
        this.seguridadService.setJwt(res.jwt);
        this.seguridadService.setAutenticacion();
        this.router.navigate(['/menu-perfil']);
      },
      (err) => {
        //console.error(err);
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Acceso denegado, motivos: el código es incorrecto, el código expiró, las credenciales de acceso no son válidas';
      }
    );
  }

  // Utilidad

  private getJwtPeticion(): IJwtPeticion {
    const usuario: string = this.getUsuario()?.value || '';
    const contrasena: string = this.getContrasena()?.value || '';
    return new JwtPeticion(usuario, contrasena);
  }

}
